import { IDENTITY, ROLE_CATEGORY } from '../constants';
import { get } from '../utility';

/**
 * Login identity for navigation: system ACLs (per-panel roles) and brokerage ACLs
 * (e.g. agent on an office without a separate agent-panel system row).
 */
export function getLoginIdentities(user: Object) {
  const systemAcls = get(user, 'systemAclsByUserId.nodes', []);
  const brokerageAcls = get(user, 'brokerageAclsByUserId.nodes', []);

  const isAgent =
    systemAcls.some((sa) => sa.roleCategory === ROLE_CATEGORY.AGENT) ||
    brokerageAcls.some((ba) => ba.roleCategory === ROLE_CATEGORY.AGENT);

  const isAdmin =
    systemAcls.some((sa) =>
      sa.roleCategory === ROLE_CATEGORY.ADMIN || sa.roleCategory === ROLE_CATEGORY.SUPER_ADMIN
    ) ||
    brokerageAcls.some((ba) => ba.roleCategory === ROLE_CATEGORY.ADMIN);

  const isCPUser = systemAcls.some((sa) =>
    sa.roleCategory === ROLE_CATEGORY.CP_ADMIN ||
    sa.roleCategory === ROLE_CATEGORY.CP_SEED_ADMIN ||
    sa.roleCategory === ROLE_CATEGORY.CP_SUPER_ADMIN
  );

  return { isAgent, isAdmin, isCPUser };
}

/** When exactly one of agent/admin/CP applies, return the profile identity string; else null. */
export function getSingleIdentityString(user: Object) {
  const { isAgent, isAdmin, isCPUser } = getLoginIdentities(user);
  const count = [isAgent, isAdmin, isCPUser].filter(Boolean).length;
  if (count !== 1) return null;
  if (isAgent) return IDENTITY.AGENT;
  if (isAdmin) return IDENTITY.ADMIN;
  if (isCPUser) return IDENTITY.CP_USER;
  return null;
}

export function getRedirectPathByRoleCategory(roleCategory: string) {

  let redirectPath = '/';

  if (roleCategory === ROLE_CATEGORY.AGENT) {
    redirectPath = '/agent/sessions';
  } else if (roleCategory === ROLE_CATEGORY.SUPER_ADMIN || roleCategory === ROLE_CATEGORY.ADMIN) {
    redirectPath = '/admin/admin-management';
  } else if (roleCategory === ROLE_CATEGORY.CP_SEED_ADMIN
    || roleCategory === ROLE_CATEGORY.CP_SUPER_ADMIN
    || roleCategory === ROLE_CATEGORY.CP_ADMIN
  ) {
    redirectPath = 'cp-user/brokerage-management';
  }

  return redirectPath;
}

export function getRedirectPathBySelectedIdentity(redirectUrl: ?string, selectedIdentity: string, firstLogin: boolean) {
  if (redirectUrl) {
    return redirectUrl;
  }

  if (selectedIdentity === IDENTITY.CP_USER) {
    return '/cp-user';
  }

  if (selectedIdentity === IDENTITY.ADMIN) {
    return '/admin';
  }

  if (selectedIdentity === IDENTITY.AGENT) {
    return '/agent/sessions';
  }

  return '/';
}
